/**
** 前台界面--项目管理界面
 */
<template>
  <div id="ProjectManag" class="jc-page">
    <div class="jc-panel jc-page-head">
      <span class="header-title">{{ headerTitle }}</span>
      <div class="header-operation">
        <el-form :inline="true" ref="queryForm" :model="searchFrom" :rules="queryRulers">
          <el-form-item>
            <el-input v-model="searchFrom.checkup_project_name" placeholder="检查项目分类名称"></el-input>
          </el-form-item>
          <!--
            <el-form-item>
              <el-cascader clearable
                v-model="searchFrom.placeOfOwnership"
                placeholder="归属地"
                :options="regionTreeList"
                :show-all-levels="false"
                :props="{value:'region_id',label:'region_name', checkStrictly:true}"></el-cascader>

            </el-form-item>
            -->
          <el-form-item>
            <el-date-picker v-model="searchFrom.start_date" type="year" placeholder="开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="endTime">
            <el-date-picker v-model="searchFrom.end_date" type="year" placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select clearable v-model="searchFrom.checkup_project_status_id" placeholder="完成状态">
              <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item> -->
          <el-button class="button" @click="query">查询</el-button>
          <!-- </el-form-item>
                        <el-form-item> -->
          <!-- <el-button class="button" @click="delect">删除</el-button> -->
          <!-- </el-form-item>
                        <el-form-item> -->
          <!-- <el-button class="button" @click="addLine">添加</el-button> -->
          <el-button class="button" @click="openCreateProjects">项目立项</el-button>
          <!-- </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="jc-table-container jc-scroll-panel" style="padding:0px;background:#f3f3f3;">
      <div style="width:calc(100% - 20px);text-align:left;padding:10px;">
        <el-card style="margin:10px;width:calc(25% - 22px);display:inline-block;float:none;font-size:14px;color:#101010;"
          v-for="(item, i) in projectList" :key="i" class="box-card"
          @click.native="goProjectEval(item.checkup_project_id)">
          <div slot="header" class="clearfix">
            <el-tooltip effect="light" :content="item.checkup_project_name">
              <span style="font-size:16px;">{{ item.checkup_project_name.length > 10 ? item.checkup_project_name.substr(0,
                10) : item.checkup_project_name }}</span>
            </el-tooltip>

            <span :style="{ color: switchStateColor(item.checkup_project_status_info.checkup_project_status_id) }"
              style="float: right; font-weight: normal">{{ item.checkup_project_status_info.checkup_project_status_name
              }}</span>
            <span :style="{ background: switchStateColor(item.checkup_project_status_info.checkup_project_status_id) }"
              style="position:relative;top:7px;margin-right:5px;float: right; display:inline-block;height:5px;width:5px;border-radius:2.5px;"></span>
          </div>
          <div class="text item">
            <span class="projectType">{{ item.checkup_project_type_info.checkup_project_type_name }}</span>
          </div>
          <div class="text item">
            <span>立项人：{{ item.checkup_project_charge_user_info.checkup_project_charge_user_name }}</span>
          </div>
          <div class="text item">
            <span>负责人：{{ item.checkup_project_charge_user_info.checkup_project_charge_user_name }}</span>
          </div>
          <div class="text item">
            <span>评估类型：{{ item.evaluation_type_info.evaluation_type_name }}</span>
          </div>
          <div class="text item">
            <span>项目评级：{{ item.level === 'Z'?'未评级':item.level }}</span>
          </div>
          <div class="text item">
            <span>接收机构：{{ item.distribute_organization_name_string.length > 7 ?
              item.distribute_organization_name_string.substring(0, 7) : item.distribute_organization_name_string
            }}</span>
          </div>
          <div class="text item" v-if="item.checkup_project_status_info.checkup_project_status_id == '20001'">
            <span>得分：{{ item.checkup_project_real_score }}分</span>
          </div>

          <div class="text item">
            <span>项目周期：{{ item.start_date + item.action_period_info.action_period_name + '至' + item.end_date +
              item.action_period_info.action_period_name }}</span>
          </div>
          <div class="progressDiv" @click.stop="">
            <el-progress type="circle" :width="56" :percentage="Math.round(item.rateOfProgress)"
              v-if="item.rateOfProgress === 100" status="success"></el-progress>
            <el-progress type="circle" :width="56" :percentage="Math.round(item.rateOfProgress)" v-else></el-progress>
            <el-dropdown style="display:block;text-align:center;" @command="changeProjectState(item, $event)">
              <span class="el-dropdown-link" style="color:#000;font-weight:bold;font-size:16px;">...</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="opt in switchStateMenu(item.checkup_project_status_info.checkup_project_status_id)"
                  :key="opt.value" :command="opt.value">{{ opt.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-card>
      </div>
      <el-dialog :close-on-click-modal="false" class="jc-dialog" :visible.sync="showAddDialog" title="项目立项"
        :before-close="cancelAddDialog">
        <el-form style="display:block;" label-position="top" :model="addFormModel" :rules="addFormRules" ref="addForm">
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目名称">
                <el-input v-model="addFormModel.checkup_project_name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目类型">
                <el-select @change="projectTypeChange" clearable v-model="addFormModel.checkup_project_type_id">
                  <el-option v-for="item in ProjectTypeList" :key="item.checkup_project_type_id"
                    :label="item.checkup_project_type_name" :value="item.checkup_project_type_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="适用机构类型">
                <el-select clearable v-model="addFormModel.checkup_project_organization_type_id"
                  @change="OrganizationTypeChange">
                  <el-option v-for="item in OrganizationTypeList" :key="item.organization_type_id"
                    :label="item.organization_type_name" :value="item.organization_type_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="评估类型">
                <el-select clearable v-model="addFormModel.evaluation_type_id">
                  <el-option v-for="item in EvaluationTypeList" :key="item.evaluation_type_id"
                    :label="item.evaluation_type_name" :value="item.evaluation_type_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="行动周期">
                <el-select clearable disabled v-model="addFormModel.action_period_id" @change="ActionPeriodChange">
                  <el-option v-for="item in ActionPeriodList" :key="item.action_period_id"
                    :label="item.action_period_name" :value="item.action_period_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="开始时间">
                <el-date-picker clearable value-format="yyyy-MM-dd" v-model="addFormModel.start_date" :type="actionPeriod"
                  placeholder="请选择开始时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间">
                <el-date-picker clearable value-format="yyyy-MM-dd" v-model="addFormModel.end_date" :type="actionPeriod"
                  placeholder="请选择结束时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="负责人">
                <el-select clearable v-model="addFormModel.checkup_project_charge_user_id">
                  <el-option v-for="item in UserList" :key="item.organization_user_id"
                    :label="item.organization_user_real_name" :value="item.organization_user_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目评级">
                <el-select clearable v-model="addFormModel.level">
                  <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="jc-dialog-section-head">本机检查表</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目">
                <el-select clearable v-model="addFormModel.base_checkup_project_id"
                  @change="TemplateCheckupProjectChange">
                  <el-option v-for="item in TemplateCheckupProjectList" :key="item.base_checkup_project_id"
                    :label="item.base_checkup_project_name" :value="item.base_checkup_project_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否打分">
                <el-select :disabled="!isScoreEnable" clearable v-model="addFormModel.is_score">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="SelfCheckupSubjectList.length > 0">
            <el-col :span="24">
              <el-form-item>
                <el-checkbox-group v-model="addFormModel.self_checkup_subject_id_list">
                  <el-checkbox v-for="item in SelfCheckupSubjectList" :label="item.base_checkup_subject_id"
                    :key="item.base_checkup_subject_id">
                    {{ item.base_checkup_subject_name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="jc-dialog-section-head">接受机构及检查表</div>
          <el-row>
            <el-col :span="24">
              <el-form-item label="接受机构">
                <el-select multiple clearable v-model="addFormModel.distribute_organization_id_list">
                  <el-option v-for="item in NextLevelOrganizationList" :key="item.organization_id"
                    :label="item.organization_name" :value="item.organization_id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="DistributeCheckupSubjectList.length > 0">
            <el-col :span="24">
              <el-form-item>
                <el-checkbox-group v-model="addFormModel.distribute_checkup_subject_id_list">
                  <el-checkbox v-for="item in DistributeCheckupSubjectList" :label="item.base_checkup_subject_id"
                    :key="item.base_checkup_subject_id">
                    {{ item.base_checkup_subject_name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelAddDialog">取 消</el-button>
          <el-button type="primary" @click="okAddDialog">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { eventBus } from "../../../eventbus/index";
import { getRegionTreeList, getCheckupProjectList } from '@/apis/projectManage'
import { getNextLevelOrganizationList, getUserList, getActionPeriodList, getOrganizationTypeList, getEvaluationTypeList, getCheckupProjectTypeList } from '@/apis/info'
import { operateCheckupProjectStatus, createCheckupProjectInfo, getDistributeCheckupSubjectList, getSelfCheckupSubjectList, getTemplateCheckupProjectList } from '@/apis/projects'
export default {
  name: "ProjectManag",
  data() {
    var validateEndTime = (rule, value, callback) => {
      // console.log(this.searchFrom)
      if (value < this.searchFrom.start_date) {
        this.$message.error('结束时间不能小于开始时间');
        callback(new Error());
      } else {
        callback();
      }
    }
    return {
      addFormModel: {
        "checkup_project_name": "",
        "checkup_project_organization_type_id": "",
        "checkup_project_type_id": "",
        "is_score": "",
        "action_period_id": "3",
        "evaluation_type_id": "",
        "start_date": "",
        "end_date": "",
        "checkup_project_charge_user_id": "",
        "base_checkup_project_id": "",
        "self_checkup_subject_id_list": [],
        "distribute_organization_id_list": [],
        "distribute_checkup_subject_id_list": [],
        "level": "Z"
      },
      addFormRules: {

      },
      showAddDialog: false,
      currentPage: 1,
      count: 1000,
      queryRulers: {
        endTime: [
          { validator: validateEndTime, trigger: 'blur' }
        ],
      },
      headerTitle: "项目管理",
      form: {
        name: "",
        place: "",
        startDate: "",
        endDate: "",
        status: "",
      },

      searchFrom: {
        checkup_project_name: "",
        placeOfOwnership: "",
        start_date: "",
        end_date: "",
        checkup_project_status_id: "",
      },
      placeOfOwnershipOptions: [],
      stateOptions: [
        {
          value: "10001",
          label: "待开始",
        },
        {
          value: "20002",
          label: "已暂停",
        },
        {
          value: "30003",
          label: "已冻结",
        },
        {
          value: "20001",
          label: "进行中",
        },
        {
          value: "30001",
          label: "已完成",
        },
        {
          value: "30002",
          label: "已归档",
        },
      ],
      rules: {},
      regionTreeList: [],
      OrganizationTypeList: [],
      EvaluationTypeList: [],
      ProjectTypeList: [],
      ActionPeriodList: [],
      actionPeriod: 'date',
      UserList: [],
      levelList: [{
        value: 'A',
        label: 'A'
      }, {
        value: 'B',
        label: 'B'
      }, {
        value: 'C',
        label: 'C'
      }, {
        value: 'D',
        label: 'D'
      }, {
        value: 'E',
        label: 'E'
      }, {
        value: 'Z',
        label: '未评级'
      }],
      TemplateCheckupProjectList: [],
      NextLevelOrganizationList: [],
      SelfCheckupSubjectList: [],
      DistributeCheckupSubjectList: [],
      projectList: [],
      isScoreEnable: true
    };
  },
  mounted() {
    this.loadBasicData()
    this.loadData()
  },
  methods: {
    openCreateProjects() {
      this.showAddDialog = true
      this.isScoreEnable = true
    },
    projectTypeChange(e) {
      let type = this.ProjectTypeList.find(x => x.checkup_project_type_id == e)
      if (type.checkup_project_type_name == "政府考核") {
        this.isScoreEnable = false
        this.addFormModel.is_score = "1"
      } else {
        this.isScoreEnable = true
      }
    },
    okAddDialog() {
      // console.log(this.addFormModel)
      let temp = []
      this.addFormModel.self_checkup_subject_id_list.forEach(x => {
        temp.push(parseInt(x))
      })
      this.addFormModel.self_checkup_subject_id_list = [...temp]
      temp = []
      this.addFormModel.distribute_checkup_subject_id_list.forEach(x => {
        temp.push(parseInt(x))
      })
      this.addFormModel.distribute_checkup_subject_id_list = [...temp]
      createCheckupProjectInfo(this.addFormModel).then(res => {
        if (res.data.status == "1") {
          this.loadData()
          this.showAddDialog = false
          this.addFormModel = {
            "checkup_project_name": "",
            "checkup_project_organization_type_id": "",
            "checkup_project_type_id": "",
            "is_score": "",
            "action_period_id": "3",
            "evaluation_type_id": "",
            "start_date": "",
            "end_date": "",
            "checkup_project_charge_user_id": "",
            "base_checkup_project_id": "",
            "self_checkup_subject_id_list": [],
            "distribute_organization_id_list": [],
            "distribute_checkup_subject_id_list": [],
            "level": "",
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    cancelAddDialog() {
      this.showAddDialog = false
      this.addFormModel = {
        "checkup_project_name": "",
        "checkup_project_organization_type_id": "",
        "checkup_project_type_id": "",
        "is_score": "",
        "action_period_id": "3",
        "evaluation_type_id": "",
        "start_date": "",
        "end_date": "",
        "checkup_project_charge_user_id": "",
        "base_checkup_project_id": "",
        "self_checkup_subject_id_list": [],
        "distribute_organization_id_list": [],
        "distribute_checkup_subject_id_list": [],
        "level": "Z",
      }
    },
    loadData() {
      this.query()
    },
    loadBasicData() {
      getRegionTreeList().then(res => {
        this.regionTreeList = res.data.data.region_tree_list
      })
      getOrganizationTypeList().then(res => {
        this.OrganizationTypeList = res.data.data.organization_type_list
      })
      getEvaluationTypeList().then(res => {
        this.EvaluationTypeList = res.data.data.evaluation_type_list
      })
      getCheckupProjectTypeList().then(res => {
        this.ProjectTypeList = res.data.data.checkup_project_type_list
      })
      getActionPeriodList().then(res => {
        this.ActionPeriodList = res.data.data.action_period_list
        console.log(this.ActionPeriodList)
      })
      getUserList({
        organization_user_real_name: '',
        pagination: {
          page: 1,
          count: 1000
        }
      }).then(res => {
        this.UserList = res.data.data.organization_user_list
      })
      getNextLevelOrganizationList().then(res => {
        this.NextLevelOrganizationList = res.data.data.organization_next_level_list
      })
    },
    TemplateCheckupProjectChange(base_checkup_project_id) {
      getSelfCheckupSubjectList({
        checkup_project_id: 0,
        base_checkup_project_id: base_checkup_project_id
      }).then(res => {

        this.SelfCheckupSubjectList = res.data.data.base_self_checkup_subject_list
      })
      getDistributeCheckupSubjectList({
        checkup_project_id: 0,
        base_checkup_project_id: base_checkup_project_id
      }).then(res => {

        this.DistributeCheckupSubjectList = res.data.data.base_distribute_checkup_subject_list
      })
    },
    OrganizationTypeChange(id) {
      getTemplateCheckupProjectList({
        organization_type_id: id
      }).then(res => {

        this.TemplateCheckupProjectList = res.data.data.base_checkup_project_list
      })
    },
    ActionPeriodChange(type) {
      let item = this.ActionPeriodList.find(x => x.action_period_id == type)
      if (item) {
        switch (item.action_period_name) {
          case '年': this.actionPeriod = 'year'; break
          case '月': this.actionPeriod = 'month'; break
          case '日': this.actionPeriod = 'date'; break
        }
      }
    },
    changeProjectState(project, option) {
      operateCheckupProjectStatus({
        "checkup_project_id": project.checkup_project_id,
        "checkup_project_status_id": option
      }).then(res => {
        if (res.data.status == "0") {
          this.$message.error(res.data.msg)
        } else {
          this.loadData()
        }

      })
    },
    switchStateMenu(value) {
      switch (value) {
        case "10001":
          return [{ value: '20001', label: '项目启动' }, { value: '30001', label: '项目冻结' }]
        case "20002":
          return [{ value: '20001', label: '项目启动' }, { value: '30001', label: '项目冻结' }]
        case "30003":
          return []
        case "20001":
          return [{ value: '20002', label: '项目暂停' }, { value: '30001', label: '项目冻结' }, { value: '30002', label: '项目完成' }]
        case "30001":
          return []
        case "30002":
          return [{ value: '30003', label: '项目归档' }]
        default:
          return [];
      }
    },
    switchStateColor(value) {
      switch (value) {
        case "10001":
          return "#EF8C2B";
        case "20002":
          return "#F02E2E";
        case "30003":
          return "#F02E2E";
        case "20001":
          return "#55AF70";
        case "30001":
          return "#0C76FE";
        case "30002":
          return "#0C76FE";
        default:
          return "#0C76FE";
      }
    },
    query() {
      // console.log(this);
      this.$refs.queryForm.validate(valid => {
        if (valid) {
          getCheckupProjectList({
            "checkup_project_name": this.searchFrom.checkup_project_name,
            "checkup_project_status_id": this.searchFrom.checkup_project_status_id,
            "start_date": this.searchFrom.start_date,
            "end_date": this.searchFrom.end_date,
            "pagination": {
              "page": this.currentPage,
              "count": this.count
            }
          }).then(res => {
            this.projectList = res.data.data.checkup_project_list
          })
        } else {
          // console.log(valid)
        }
      })
      //  this.$router.push('/projectManag/ProjectManag')
      // this.$router.push({path:'/projectManag/ProjectManag',query: {id:'1'}})
      //this.$router.push("/projectManag/ProjectDetail");
    },
    delect() {
      // console.log(this);
      //  this.$router.push('/projectManag/ProjectManag')
      // this.$router.push({path:'/projectManag/ProjectManag',query: {id:'1'}})
      // this.$router.push("/projectManag/ChecklistEdit");
    },
    goProjectEval(val) {
      this.$router.push("/projectManag/ProjectDetail/" + val);
    },
  },
};
</script>
<style scoped>
.item {
  margin-bottom: 10px;
}

.item .projectType {
  border: 2px solid #ccc;
  padding: 3px 5px;
  box-sizing: border-box;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 24%;
  height: 280px;
  float: left;
  margin-right: 20px;
  margin-top: 20px;
  cursor: pointer;
}

#ProjectManag>>>.el-card__header {
  padding: 10px 20px;
  text-align: left;
  padding-top: 20px;
  font-weight: bold;
  border-bottom: none;
}

#ProjectManag>>>.el-card__body {
  padding: 0 20px;
  text-align: left;
}

.progressDiv {
  /* width: 50px; */
  /* height: 50px; */

  /* background: antiquewhite; */
  top: -80px;
  /* left: 90%; */
  position: relative;
  float: right;
  right: -15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Orgin/ProjectManag/ProjectManag.vue